import { useCallback, useEffect, useRef, useState } from 'react';
import { MAX_NAME_LENGTH } from './constants';

const HINT_DURATION_MS = 2500;

/**
 * Clamps a typed name to {@link MAX_NAME_LENGTH} and briefly flags when the
 * user tried to type past it. Clamping in the change handler (instead of the
 * native maxLength attribute) means the over-long attempt is still seen on
 * every keyboard, including Android's, so the hint can explain the stop.
 */
export function useNameLimit() {
  const [showHint, setShowHint] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  const limit = useCallback((value: string) => {
    if (value.length <= MAX_NAME_LENGTH) return value;
    setShowHint(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setShowHint(false), HINT_DURATION_MS);
    return value.slice(0, MAX_NAME_LENGTH);
  }, []);

  return { limit, showHint };
}
